// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sc-0";
export var checkoutRateBadgeLink = "_sc-1";